import React, { useEffect } from "react";
import {
  Button,
  Descriptions,
  Breadcrumb,
  PageHeader,
  Tag,
  Timeline,
} from "antd";
import { useState } from "react";
import { connect } from "react-redux";


import { Title, Wrapper } from "./detailStyle";
import { Content } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import {
  CheckSquareFilled,
  WarningOutlined,
} from "@ant-design/icons";

import Remarks from "../../component/remark";

import { getBatchDetails, updateBatchActive } from "../../actions/code";
import moment from "moment";
const CodeMDetails = ({
  location,
  getBatchDetails,
  updateBatchActive,
  
}) => {
  const [data, setData] = useState([]);

  const [status, setStatus] = useState(null);

  const [remarkaccount, setRemarkAccount] = useState(false);
  useEffect(async () => {
    const id = new URLSearchParams(location.search).get("batch");


    const res = await getBatchDetails(id);

    setData(res);
  }, []);

 
  const handleRefresh = async () => {
    const res = await getBatchDetails(data?.batch?.batch_id);

    setData(res);
  };

  const makeLocalTime = (date) => {
    let hours = date.split("T")[1].split(":")[0];
    let minutes = date.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours == 12) {
      am = false;
    } else if (hours == 0) {
      hours = 12;
    }
    return (
      date.split("T")[0] +
      "," +
      hours +
      ":" +
      minutes +
      " " +
      (am ? "A.M" : "P.M")
    );
  };
  const handleblocking = (status) => {
    setStatus(status);
    setRemarkAccount(true);
  };
  return (
    <Content>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Batch Details</Breadcrumb.Item>
      </Breadcrumb>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Batch Details"
        subTitle="Code Management"
      ></PageHeader>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      {data?.batch?.active === "active" ? (
        <Tag color="#6fcf20">Enable</Tag>
      ) : (
        <Tag color="#e96710">Disable </Tag>
      )}
      <Tag color="#c237a4">
        {moment(data?.batch?.created_at).format("llll")}
      </Tag>
      {data?.batch?.active === "inactive" ? (
        <Button
          type="ghost"
          icon={<CheckSquareFilled />}
          size="small"
          style={{
            float: "right",
            backgroundColor: "#568008",
            color: "#fff",
          }}
          onClick={() => {
            handleblocking("active");
          }}
        >
          Make Enable Batch
        </Button>
      ) : (
        <Button
          type="ghost"
          icon={<WarningOutlined />}
          size="small"
          style={{
            float: "right",
            backgroundColor: "#f04545",
            color: "#fff",
          }}
          onClick={() => {
            handleblocking("inactive");
          }}
        >
          Make Disable Batch
        </Button>
      )}
      <Wrapper>
        <Title>Batch </Title>
        <br />
        <Descriptions>
          <Descriptions.Item label="Id">
            <strong>{data?.batch?.batch_id}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Title">
            <strong>{data?.batch?.title}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Batch No">
            <strong>{data?.batch?.batch_no}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <strong>{data?.batch?.status}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Total Code">
            <strong>{data?.batch?.code_count}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Price">
            <strong>{data?.batch?.price}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Code Type">
            <strong>{data?.batch?.code_type}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="File Type">
            <strong>{data?.batch?.file_type}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="durability">
            <strong>{data?.batch?.life_time}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Description">
            <strong>{data?.batch?.description}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Weight">
            <strong>
              {data?.batch?.weight} {data?.batch?.weight_unit}
            </strong>
          </Descriptions.Item>

          <Descriptions.Item label="Manufacture Date">
            <strong>
              {moment(data?.batch?.data?.batch?.manufacture_date).format(
                "llll"
              )}
            </strong>
          </Descriptions.Item>
          <Descriptions.Item label="Expire Date">
            <strong>{moment(data?.batch?.expire_date).format("llll")}</strong>
          </Descriptions.Item>
        </Descriptions>
        {data?.batch?.product ? (
          <>
            <Title>Product </Title>
            <br />
            <Descriptions>
              <Descriptions.Item label="ID">
                <strong>{data?.batch?.product?.product_id}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="Name ">
                <strong>{data?.batch?.product?.name}</strong>
              </Descriptions.Item>

              <Descriptions.Item label="Thumbnail">
                <img
                  style={{ width: "60px" }}
                  src={`${process.env.REACT_APP_API_BASE_URL}/files/${data?.batch?.product?.thumbnail}`}
                />
              </Descriptions.Item>
              <Descriptions.Item label="Image">
                <img
                  style={{ width: "60px" }}
                  src={`${process.env.REACT_APP_API_BASE_URL}/files/${data?.batch?.product?.image}`}
                />
              </Descriptions.Item>
            </Descriptions>
          </>
        ) : null}
        <br />
        <Title>Client </Title>
        <br />
        <Descriptions>
          <Descriptions.Item label="ID">
            <strong>{data?.batch?.client?.user_id}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Name">
            <strong>{data?.batch?.client?.name}</strong>
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            <strong>{data?.batch?.client?.email}</strong>
          </Descriptions.Item>
        </Descriptions>
        <br />
        {data?.batch?.logs ? (
          <Timeline mode="left">
            {data.batch.logs.map((item, index) => (
              <Timeline.Item
                label={makeLocalTime(item?.created_at)}
                keys={index}
              >
                {item?.message}
              </Timeline.Item>
            ))}
          </Timeline>
        ) : null}

        <br />
        <br />
      </Wrapper>
      <Remarks
        title=" "
        btn="Submit"
        placement="bottom"
        visible={remarkaccount}
        fnc={() => setRemarkAccount(false)}
        id={[data?.batch?.batch_id, status]}
        delFnc={updateBatchActive}
        refresh={handleRefresh}
      />
    </Content>
  );
};

export default connect(null, {
  
  getBatchDetails,
  updateBatchActive,
  
})(CodeMDetails);
